import { gql } from '@grandvisionhq/graphql';

const contactLensesTypeDetails = gql`
  fragment ContactLensesTypeDetailsFragment on ContactLensesTypeDetails {
    eyeSide
    __typename
  }
`;

export { contactLensesTypeDetails };
//# sourceMappingURL=contact-lenses.js.map
